"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mandate = void 0;
class Mandate {
}
exports.Mandate = Mandate;
//# sourceMappingURL=Mandate.js.map